const initSportStuffHero = (root) => {
  if (root.dataset.heroInitialized === 'true') return;

  const slides = Array.from(root.querySelectorAll('.sportstuff-campaign-hero__slide'));
  const dots = Array.from(root.querySelectorAll('.sportstuff-campaign-hero__dots button'));
  if (!slides.length) return;

  let current = 0;
  let startX = null;
  let startY = null;
  let dragged = false;

  const select = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === current;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.tabIndex = active ? 0 : -1;
    });
    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === current;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  };

  const finishSwipe = (clientX, clientY) => {
    if (startX == null || startY == null) return;
    const deltaX = clientX - startX;
    const deltaY = clientY - startY;
    startX = null;
    startY = null;
    if (Math.abs(deltaX) >= 42 && Math.abs(deltaX) > Math.abs(deltaY)) {
      dragged = true;
      select(current + (deltaX < 0 ? 1 : -1));
    }
  };

  root.querySelector('.sportstuff-campaign-hero__arrow--previous')?.addEventListener('click', () => select(current - 1));
  root.querySelector('.sportstuff-campaign-hero__arrow--next')?.addEventListener('click', () => select(current + 1));
  dots.forEach((dot, index) => dot.addEventListener('click', () => select(index)));

  root.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    startX = event.clientX;
    startY = event.clientY;
    dragged = false;
  });
  root.addEventListener('pointerup', (event) => finishSwipe(event.clientX, event.clientY));
  root.addEventListener('pointercancel', () => { startX = null; startY = null; });
  root.addEventListener('touchstart', (event) => {
    const touch = event.changedTouches[0];
    startX = touch?.clientX ?? null;
    startY = touch?.clientY ?? null;
    dragged = false;
  }, { passive: true });
  root.addEventListener('touchend', (event) => {
    const touch = event.changedTouches[0];
    if (touch) finishSwipe(touch.clientX, touch.clientY);
  }, { passive: true });
  root.addEventListener('dragstart', (event) => event.preventDefault());
  root.addEventListener('click', (event) => {
    if (!dragged) return;
    event.preventDefault();
    dragged = false;
  }, true);

  root.dataset.heroInitialized = 'true';
};

document.querySelectorAll('.sportstuff-campaign-hero').forEach(initSportStuffHero);
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll?.('.sportstuff-campaign-hero').forEach(initSportStuffHero);
});
